export { default } from './DetailedCarFullSpecification';
